<!--
 * @Author: yangchuanqi
 * @Date: 2021-01-04 10:58:19
 * @LastEditTime: 2021-01-06 21:18:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\appeal\index.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">校园意见箱</router-link>
        &gt; 师生诉求
      </div>
    </div>
    <div style="color: #323333; font-size: 16px">
      <div style="
          width: 100%;
          font-family: '微软雅黑';
          color: #f00;
          font-size: 22px;
          margin-top: 20px;
          text-align: center;
        ">
        前 言
      </div>
      <br/>
      <div style="text-indent: 32px">
        一、“师生诉求”栏目主要受理您对学校有关法规、政策、程序、效果等问题的表扬、咨询、反映、建议和投诉以及在学校学习、工作和生活过程中对公共设备设施等的报修、
        一般问题会在1~3个工作日内回复；情况复杂的有可能适当延长，但最长不会超过7个工作日。对于有些重大问题，无法在7个工作日回复的，我们会及时转送学校。
      </div>
      <div style="text-indent: 32px">
        二、“师生诉求”的办理流程：师生来信--&gt;阳光校务服务中心受理--&gt;转发至相关领导或职能部门、学院（部）--&gt;回复办理进程及结果。
      </div>
      <div style="text-indent: 32px">三、“师生诉求”栏目处理方式：</div>
      <div style="text-indent: 48px">
        (一)来信内容凡涉及到学校工作的意见和建议，我们将交给服务中心负责人批办，并呈分管校领导审阅或转交相关部门处理。
      </div>
      <div style="text-indent: 48px">
        (二)来信内容凡涉及相关部门业务的，我服务中心会及时交给相关部门办理。
      </div>
    </div>
    <div class="btns">
      <a-button size="large" @click="handlerAction" type="danger">我要投诉</a-button>
      <a-button
          size="large"
          @click="go('/reply')"
          style="margin-left: 15px"
          type="primary">查看回复
      </a-button>
    </div>
    <a-modal
        title="请选择服务类型"
        :visible="visible1"
        :footer="false"
        @cancel="visible1 = false"
    >
      <div class="imgs">
        <div v-for="(item,index) in categoryList" :key="'info1-'+index" v-show="item.name==='我要咨询'"
             :class="'appealItemBack'+0" @click="go('/appealDo', item)" class="appealItem">
          <img class="appealItemImg" src="@/assets/b_1.png" alt="">
          <span>{{ item.name }}</span>
        </div>
        <div :class="'appealItemBack'+1" @click="visible3=true" class="appealItem">
          <img class="appealItemImg" src="@/assets/b_2.png" alt="">
          <span>表扬和建议</span>
        </div>
<!--        <div :class="'appealItemBack'+2" @click="alertMessage('正在开发，敬请期待!请先移步企业微信审批!')" class="appealItem">-->
<!--          <img class="appealItemImg" src="@/assets/b_3.png" alt="">-->
<!--          <span>我要报修</span>-->
<!--        </div>-->
<!--        <div :class="'appealItemBack'+2" @click="repair" class="appealItem">-->
<!--          <img class="appealItemImg" src="@/assets/b_3.png" alt="">-->
<!--          <span>我要报修</span>-->
<!--        </div>-->
<!--        <div @click="alertMessage('正在开发，敬请期待!')" class="appealItem" >-->
<!--          <img class="appealItemImg" src="@/assets/b_6.png" alt="">-->
<!--          失物招领-->
<!--        </div>-->
        <div @click="swzl" class="appealItem" >
          <img class="appealItemImg" src="@/assets/b_6.png" alt="">
          失物招领
        </div>
        <div v-for="(item,index) in categoryList" :key="'info3-'+index" v-show="item.name==='我要投诉'"
             :class="'appealItemBack'+index" @click="go('/appealDo', item)" class="appealItem">
          <img class="appealItemImg" src="@/assets/b_4.png" alt="">
          <span>{{ item.name }}</span>
        </div>
        <div v-for="(item,index) in categoryList" :key="'info2-'+index" v-show="item.name==='领导信箱'"
             :class="'appealItemBack'+index" @click="go('/appealDo', item)" class="appealItem">
          <img class="appealItemImg" src="@/assets/b_5.png" alt="">
          <span>{{ item.name }}</span>
        </div>
      </div>
      <a-modal
          title="请失物招领类型"
          :visible="visible2"
          :footer="false"
          @cancel="visible2 = false"
      >
        <div class="lostItems">
          <div @click="goLostAndFound('/lostAndFound',1)" class="lostItem">
            <a-icon type="caret-right" theme="filled"/>
            失物信息查询
          </div>
          <div
              style="background-color: #e8b65f"
              @click="goLostAndFound('/lostAndFound',2)"
              class="lostItem"
          >
            <a-icon type="caret-right" theme="filled"/>
            招领信息查询
          </div>
          <div
              style="background-color: #c87446"
              @click="go('/lostAndFound/lost')"
              class="lostItem"
          >
            <a-icon type="caret-right" theme="filled"/>
            失物信息发布
          </div>
          <div
              style="background-color: #7aae70"
              @click="showLostMessage"
              class="lostItem"
          >
            <a-icon type="caret-right" theme="filled"/>
            招领信息发布
          </div>
        </div>
      </a-modal>
      <a-modal
          title="表扬和建议"
          :visible="visible3"
          :footer="false"
          @cancel="visible3 = false"
      >
        <div class="lostItems">
          <div v-for="(item,index) in categoryList" :key="'info1-'+index" v-show="item.name==='我要表扬'"
               style="background-color:rgb(253,132,105)" @click="go('/appealDo', item)" class="lostItem">
            <a-icon type="caret-right" theme="filled"/>
            {{ item.name }}
          </div>
          <div v-for="(item,index) in categoryList" :key="'info2-'+index" v-show="item.name==='我要建议'"
               @click="go('/appealDo', item)" class="lostItem">
            <a-icon type="caret-right" theme="filled"/>
            {{ item.name }}
          </div>
        </div>
      </a-modal>
    </a-modal>
    <a-modal
        title="我要报修"
        :visible="visible4"
        :footer="false"
        destroyOnClose
        @cancel="visible4 = false"
    >
      <div id="qrCodeUrl" class="qrcode" ref="qrCodeUrl"></div>
    </a-modal>
  </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";

export default {
  data() {
    return {
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      categoryList: [],
    };
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    repair() {
      this.visible4 = true
      this.$nextTick(() => {
        window.WwLogin({
          "id": "qrCodeUrl",
          "appid": window._CONFIG["appid"],
          "agentid": window._CONFIG["agentid"],
          "redirect_uri": window._CONFIG["redirect_uri"],
          "state": "STATE",
          "href": "",
        });
      })
    },
    showLostMessage() {
      this.$notification["info"]({
        message: "信息",
        description:
            "如果您拾到了他人物品，请将物品交给阳光校务服务值班学生或者各部门阳光校务服务中心信息员（本具体见本网站的“联系我们”）。他们会及时在网上发布信息找寻失主，向拾金不昧、助人为乐的您致敬！",
        duration: 5,
      });
    },
    alertMessage(content) {
      this.$info({
        title: '提示',
        content: content,
        onOk() {
        }
      })
    },
    swzl() {
      this.visible2 = true;
    },
    getCategoryList() {
      postAction("/user/appeal/category/categoryList").then((data) => {
        this.categoryList = data.data.list;
      });
    },
    go(url, item) {
      if (item) {
        if (item.name === '领导信箱') {
          this.$router.push({
            path: '/leaderDo',
          });
        } else {
          this.$router.push({
            path: url,
            query: {
              record: encodeURIComponent(JSON.stringify(item)),
            },
          });
        }
      } else {
        this.$router.push(url)
      }
    },
    goLostAndFound(url, type) {
      this.$router.push({
        path: url,
        query: {
          type: type
        }
      })
    },
    handlerAction() {
      this.visible1 = true;
    },
    handlerSee() {
      this.visible1 = true;
    },
  },
};
</script>

<style scoped>
.itemsList {
  margin-top: 20px;
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btns {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.imgs,
.lostItems {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.appealItem {
  width: 49%;
  margin-bottom: 20px;
  cursor: pointer;
  padding: 15px 30px;
  background-color: rgb(233, 104, 39);
  color: #fff;
  font-size: 20px;
}

.appealItemBack0 {
  background-color: rgb(40, 151, 233);
}

.appealItemBack1 {
  background-color: rgb(76, 198, 245);
}

.appealItemBack2 {
  background-color: rgb(255, 177, 41);
}

.appealItemBack3 {
  background-color: rgb(66, 111, 178);
}

.appealItemBack4 {
  background-color: rgb(66, 178, 96);
}

.appealItem:hover {
  opacity: 0.8;
}

.appealItemImg {
  width: 55px;
  margin-right: 13px;
}

.img,
.lostItem {
  width: 49%;
  margin-bottom: 20px;
  cursor: pointer;
}

.img:hover {
  opacity: 0.8;
  transition: 0.5s;
}

.lostItem {
  height: 55px;
  line-height: 55px;
  text-align: center;
  background-color: #6395de;
  color: #fff;
  font-size: large;
}
.qrcode {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
